
$(function () {
  var $slider = $('#js-top-slider');
 
  $slider.slick({
    arrows: false, // 前・次のボタンを表示しない
    autoplay: true,
    dots: true, // ドットナビゲーションを表示する
    appendDots: $('.dots'), // ドットナビゲーションの生成位置を変更
    speed: 800, // スライドさせるスピード（ミリ秒）
    slidesToShow: 1, // 表示させるスライド数
    centerMode: true, // slidesToShowが奇数のとき、現在のスライドを中央に表示する
    variableWidth: true, // スライド幅の自動計算を無効化
  });

/*--- プログレスバー設定 -----------------------*/
  var
    time = 2,
    $bar = $('.dots .slick-dots li.slick-active button'),
    isPause,
    tick,
    percentTime;
  function startProgressbar() {
    resetProgressbar();
    percentTime = 0;
    isPause = false;
    tick = setInterval(interval, 10);
  }
  function interval() {
    if (isPause === false) {
      percentTime += 1 / (time + 0.1);
      $bar = $('.dots .slick-dots li.slick-active button');
      $bar.css({
        width: percentTime + "%"
      });
      if (percentTime >= 100) {
        $slider.slick('slickNext');
        startProgressbar();
      }
    }
  }
  function resetProgressbar() {
    $bar = $('.dots .slick-dots li.slick-active button');
    $bar.css({
      width: 0 + '%'
    });
    clearTimeout(tick);
  }
  startProgressbar();
   
  // カーソルが乗ったら止める
  $slider.on({
    mouseenter: function () { isPause = true; },
    mouseleave: function () { isPause = false; }
  });
   
  // ドットがクリックされたら再発火(スライド切り替え前のイベント)
  $slider.on('beforeChange', function (slick, currentSlide, nextSlide) {
    startProgressbar();
  });
});